import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const ITGlossaryBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "IT Glossary Block",
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  canHaveChildren: false,
  inputs: [
    {
      name: "glossaryTableHeaders",
      type: "list",
      required: true,
      subFields: [
        {
          name: "label",
          type: "string",
          required: true,
          localized: true,
          defaultValue: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Tab Label",
          },
        },
        DLT_FIELD,
        DLD_FIELD,
      ],
      defaultValue: [
        {
          label: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Term",
          },
        },
        {
          label: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Description",
          },
        },
        {
          label: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Solution",
          },
        },
      ],
    },
  ],
};
